import React, { Fragment, useContext } from "react";
import Auction from "../components/Auction";
import { AuthContext } from "../context/authContext";

export default function Game() {
  const { currentUser } = useContext(AuthContext);

  return (
    <Fragment>
      <div className="main-content right-chat-active bg-white game-page" style={{ paddingTop: '65px' }}>
        <div className="middle-sidebar-bottom" style={{ padding: 0, marginTop: 0 }}>
          <div className="middle-sidebar-left pe-0" style={{ padding: '10px', paddingTop: 0 }}>
            <Auction />
          </div>
        </div>
      </div>
    </Fragment>
  );
}

